
<template>
  <div class="limitBox">
    <div class="box"
         v-if="dataList.length>0">
      <p v-for="(item,index) in dataList"
         :key="index"
         class="bankName">{{item.bankName}}</p>
    </div>
    <div class="noData"
         v-else>
      暂无数据
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      dataList: [],
      orderId: ''
    }
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.util.title('支持银行');
    this.getDetails()
  },
  methods: {
    getDetails () {
      let _this = this;
      let param = {
        orderId: this.orderId
      }
      this.$get('/app/api/v1/supporting/banks', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            _this.dataList = e.data;
          }
          else {
            _this.util.toast({ msg: e.message })
          }
        })
        .catch(error => { });
    },
  }

}
</script>
<style>
.limitBox .ivu-timeline-item-tail {
  border-left: 1px solid #ededed;
}
</style>
<style scoped>
.limitBox {
  background: #f7f7f7;
  padding: 0.15rem 0;
  font-size: 0.13rem;
  color: #929196;
}
.box {
  background: #ffffff;
  width: 100%;
}
.bankName {
  color: #666;
  font-size: 0.13rem;
  display: inline-block;
  width: 33.33%;
  border-right: 1px solid #f7f7f7;
  border-bottom: 1px solid #f7f7f7;
  /* border-left: 1px solid #f7f7f7; */
  padding: 0.2rem 0;
  text-align: center;
}
.noData {
  text-align: center;
  padding-top: 0.5rem;
  font-size: 0.16rem;
}
</style>
